import channelsUtil from '../helpers/channelsUtil';
import h from '../helpers/common';

export type ProgramTag = {
    scheme: string;
    title: string;
};
export type Image = {
    type: string;
    url: string;
};

export type Listing = {
    guid?: string;
    id?: string;
    startTime: string;
    recordingStartTime?: string;
    endTime: string;
    stationId?: string;
};

export type RewindLinear = {
    Id: string;
    guid: string;
    name: string;
    text: string;
    image: string;
    ratings: string;
    dateTime?: string;
    startTime?: string;
    recordingStartTime?: string;
    endTime?: string;
    stationId: string;
    year: string;
    category: 'LINEAR';
    tags: ProgramTag[];
    genre: string[];
    channelName: string;
    channelNumber: string;
    channelCategory?: string;
    channelId: string;
    listingId: string;
    listings: Listing[];
    description: string;
    programType: 'Rewind';
    subscriptionGuids: string[];
};

export function transformRewind(rewind: any, providers: any, lang: string): RewindLinear {
    const listingObj: any = rewind.lastAirListing || (rewind.listings && rewind.listings[0]) || {};

    // Find cover image using native array methods
    const coverImage = rewind.images.find((img) => img.type === 'cover');

    // Filter genres using native array methods
    const genres = rewind.programTags
        ? rewind.programTags.filter((tag) => tag.scheme === 'Genre' && tag.title).map((tag) => tag.title)
        : [];

    return {
        Id: rewind.id,
        guid: rewind.guid || listingObj.guid || '',
        name: rewind.title,
        text: h.getLang() === 'en' ? rewind.title : rewind.titleLocalized.ar,
        image: coverImage?.url || '',
        ratings: h.getGenreRating(rewind.parentalRatings || rewind.ratings) || '',
        dateTime: listingObj.startTime && channelsUtil.formatPastDuration(new Date(listingObj.startTime).getTime()),
        startTime: listingObj.startTime,
        recordingStartTime: listingObj?.recordingStartTime ?? listingObj.startTime,
        endTime: listingObj.endTime,
        stationId: listingObj.stationId || '',
        year: rewind.year || '',
        category: 'LINEAR',
        tags: rewind.programTags || [],
        genre: genres,
        channelName: rewind.channelName,
        channelNumber: rewind.channelNumber,
        ...(rewind.category?.[0] && {
            channelCategory: rewind.category[0],
        }),
        channelId: rewind.channelId,
        listingId: listingObj.id || '',
        listings: rewind.listings || [],
        description: h.getLang() === 'en' ? rewind.description : rewind.descriptionLocalized.ar,
        programType: 'Rewind',
        subscriptionGuids: rewind.subscriptionGuids,
    };
}

type VodItem = {
    Id: string;
    guid: string;
    name: string;
    text: string;
    description: string;
    image: string;
    image_landscape: string;
    year: string;
    tags: ProgramTag[] | undefined;
    genre: string[];
    provider: string[];
    categories: string[];
    ratings: string;
    episodeNumber?: number;
    seasonNumber?: number;
    duration: number;
    category: 'VOD';
    programType: string;
    purchaseStatus: string;
    productId: string;
    subscriptionGuids: string[];
};

export function transformVodItem(vod: any, providers: any, lang: string): VodItem {
    const currentLang = lang;

    // Find images using native array methods
    const posterImage = vod.images.find((img) => img.type === 'poster');
    const coverImage = vod.images.find((img) => img.type === 'cover');

    // Process program tags using native array methods
    const genres = vod.programTags
        ? vod.programTags.filter((tag) => tag.scheme === 'Genre' && tag.title).map((tag) => tag.title)
        : [];

    const providerTags = vod.programTags
        ? vod.programTags.filter((tag) => tag.scheme === 'Categories' && tag.title in providers).map((tag) => tag.title)
        : [];

    const categoryTags = vod.programTags
        ? vod.programTags
              .filter((tag) => tag.scheme === 'Categories' && !(tag.title in providers))
              .map((tag) => tag.title)
        : [];

    return {
        Id: vod.id,
        guid: vod.guid || '',
        name: vod.title,
        text: currentLang === 'en' ? vod.title : vod.titleLocalized.ar,
        description: currentLang === 'en' ? vod.description : vod.descriptionLocalized.ar,
        image: posterImage?.url || '',
        image_landscape: coverImage?.url || '',
        year: vod.year,
        tags: vod.programTags,
        genre: genres,
        provider: providerTags,
        categories: categoryTags,
        ratings: h.getGenreRating(vod.parentalRatings) || '',
        episodeNumber: vod.episodeNumber,
        seasonNumber: vod.seasonNumber,
        duration: vod.duration,
        category: 'VOD',
        programType: vod.programType,
        purchaseStatus: vod.purchaseStatus,
        productId: vod.productId,
        subscriptionGuids: vod.subscriptionGuids,
    };
}
